import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer>
      Coded by{" "}
      <a
        href="https://www.linkedin.com/in/sarah-barter-6383b196/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Sarah Barter
      </a>{" "}
      and open-sourced on{" "}
      <a
        href="https://github.com/barty-s/weather_app_react"
        target="_blank"
        rel="noreferrer"
      >
        GitHub
      </a>
    </footer>
  );
}
